import React, { useMemo, useState, useRef, useEffect } from 'react';
import { TranslateScope } from '@pegasus/translation';
import { useEducationalMessage, HideEducationalMessageCookieNames, } from '@pegasus/platform-journeys';
import { EmptyCart } from './EmptyCart';
import { CartInfo } from './CartInfo';
import { CartItems } from './CartItems';
import { Wrapper, Container } from './styles';
import { arrangeRecoveredItems } from './helpers';
export const Cart = ({ items = [], recoveredItems = [], isOpen, info, languageCode, events, isPlusEnabled, isPlatformJourneyEnabled, showSuccessMessage, showNotification, isSubscribedToNewsletter, isDOIUser, subscribeToNewsletter, email, firstName, csrfToken, hasSecondaryAuth, onNavigationChange, }) => {
    const arrangedRecoveredItems = useMemo(() => arrangeRecoveredItems(items, recoveredItems), [
        items,
        recoveredItems,
    ]);
    const allItems = useMemo(() => [...items, ...arrangedRecoveredItems], [
        items,
        arrangedRecoveredItems,
    ]);
    const { isVisible } = useEducationalMessage({
        isPlatformJourneyEnabled,
        uniqueHideCookieName: HideEducationalMessageCookieNames.Cart,
    });
    const [isEducationalMessageVisible, setIsEducationalMessageVisible] = useState(isVisible);
    const onHideEducationalMessage = () => {
        setIsEducationalMessageVisible(false);
    };
    const [cartInfoHeight, setCartInfoHeight] = useState(0);
    const cartInfoRef = useRef();
    useEffect(() => {
        var _a;
        const nextCartInfoHeight = ((_a = cartInfoRef === null || cartInfoRef === void 0 ? void 0 : cartInfoRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
        setCartInfoHeight(nextCartInfoHeight);
    }, [isEducationalMessageVisible, isOpen]);
    return (React.createElement(Wrapper, { isOpen: isOpen, itemsCount: allItems.length, cartInfoHeight: cartInfoHeight },
        React.createElement(Container, { isOpen: isOpen, itemsCount: allItems.length, cartInfoHeight: cartInfoHeight },
            React.createElement(TranslateScope, { path: "cart" },
                React.createElement(React.Fragment, null,
                    items.length === 0 ? (React.createElement(EmptyCart, { onNavigationChange: onNavigationChange })) : (info && (React.createElement(CartInfo, { ...info, languageCode: languageCode, onCheckoutClick: events.onCheckoutClick, isPlatformJourneyEnabled: isPlatformJourneyEnabled, showSuccessMessage: showSuccessMessage, showNotification: showNotification, isSubscribedToNewsletter: isSubscribedToNewsletter, isDOIUser: isDOIUser, subscribeToNewsletter: subscribeToNewsletter, onHideEducationalMessage: onHideEducationalMessage, email: email, firstName: firstName, csrfToken: csrfToken, hasSecondaryAuth: hasSecondaryAuth, ref: cartInfoRef }))),
                    allItems.length > 0 && (React.createElement(CartItems, { items: items, recoveredItems: arrangedRecoveredItems, languageCode: languageCode, onItemClick: events.onItemClick, onItemRemove: events.onItemRemove, onItemReserveAgain: events.onItemReserveAgain, isPlusEnabled: isPlusEnabled, cartInfoHeight: cartInfoHeight })))))));
};
//# sourceMappingURL=index.js.map